<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active toUpper" aria-current="page">{{ $t('language') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$refs.file.click()"><i class="fa fa-cloud-upload" aria-hidden="true"></i> {{$t('import_json_file')}}</button>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="jsonView"><i class="fa fa-file-code-o"></i> View As Json</button>
            <div class="pull-right">
                <select class="form-control form-control-sm" v-model="langType">
                    <option value="kh">Khmer</option>
                    <option value="en">English</option>
                </select>
            </div>
        </div>
        <div class="x_body">
            <input type="file" ref="file" accept="application/json" style="display: none;" @change="onJsonSelect">
            <div class="card n_card no-bor">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="text" class="form-control form-control-sm" placeholder="Search..." v-model="query.Text" @keypress.enter="toList">
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.LangType" @change="toList">
                                    <option value="">All</option>
                                    <option value="kh">Khmer</option>
                                    <option value="en">English</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr>
                                <th class="text-center">{{ $t('no') }}</th>
                                <th>{{ $t('code') }}</th>
                                <th>{{ $t('lang_khmer') }}</th>
                                <th>{{ $t('lang_english') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in records" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><input type="text" class="form-control form-control-sm" v-model="ret.Code" readonly /></td>
                                <td><input type="text" class="form-control form-control-sm" v-model="ret.LangKh" @blur="onChange(ret)" /></td>
                                <td><input type="text" class="form-control form-control-sm" v-model="ret.LangEn" @blur="onChange(ret)" /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <b-modal v-model="isShowModal" size="lg" no-close-on-backdrop hide-footer>
            <div>
                <button type="button" class="btn btn-outline-success btn-sm" @click="onCopy">Copy</button>
            </div>
            <json-viewer :value="json" :expanded="true" :copyable="true"></json-viewer>
        </b-modal>
    </div>
</template>
<script>
import Vue from 'vue'
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)
export default {
    data(){
        return{
            langType: 'kh',
            query: {
                Text: '',
                LangType: ''
            },
            records: [],
            formHead: { headers: { 'Content-Type': 'multipart/form-data' }},
            isShowModal: false
        }
    },
    created(){
        this.toList();
    },
    methods: {
        toList(){
            var loading = this.$loading.show();
            this.$api().post('system/translate-language', this.query).then(res => {
                if(this.$isValid(res)){
                    this.records = res.data.Json.Languages;
                }
            }).finally(function() { loading.hide(); });
        },
        onJsonSelect(){
            var loading = this.$loading.show();
            var formData = new FormData();
            formData.append('File', this.$refs.file.files[0]);
            formData.append('LangType', this.langType);
            this.$api().post('system/json-import-translate-language', formData, this.formHead).then(res => {
                if (this.$isValid(res)) {
                    this.toList();
                }
            }).finally(function () {
                loading.hide();
            });
        },
        onChange(item){
            this.$api().post('system/save-translate-language', item).then(res => {
                if(this.$isValid(res)){}
            });
        },
        jsonView(){
            this.isShowModal = true;
        },
        onCopy(){
            navigator.clipboard.writeText(JSON.stringify(this.json));
        }
    },
    computed: {
        json(){
            let json = {};
            for(var i = 0; i < this.records.length; i++){
                json[this.records[i].Code] = this.langType =='kh'?this.records[i].LangKh:this.records[i].LangEn;
            }
            return json;
        }
    }
}
</script>